import { Controller } from "@hotwired/stimulus"
import { Swiper } from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"

// Enveloppe générique de Swiper, pilotée par des attributs data (repris de koromy) :
//   data-controller="swiper-slider"
//   data-swiper-slider-loop-value="true"
//   data-swiper-slider-autoplay-value="6000"      (ms ; absent ou 0 = pas de défilement)
//   data-swiper-slider-slides-per-view-value="1"  (nombre ou "auto")
//   data-swiper-slider-space-between-value="0"
//   data-swiper-slider-navigation-value="true"    (flèches)
//   data-swiper-slider-pagination-value="true"    (points)
// La feuille de style de Swiper est importée par application.bootstrap.scss.
export default class extends Controller {
  static values = {
    loop: { type: Boolean, default: false },
    autoplay: { type: Number, default: 0 },
    slidesPerView: { type: String, default: "1" },
    spaceBetween: { type: Number, default: 0 },
    navigation: { type: Boolean, default: false },
    pagination: { type: Boolean, default: false },
    breakpoints: { type: Object, default: {} }
  }

  connect() {
    const slidesPerView = this.slidesPerViewValue === "auto" ? "auto" : Number(this.slidesPerViewValue)

    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination, Autoplay],
      loop: this.loopValue,
      slidesPerView,
      spaceBetween: this.spaceBetweenValue,
      breakpoints: Object.keys(this.breakpointsValue).length ? this.breakpointsValue : undefined,
      autoplay: this.autoplayValue > 0
        ? { delay: this.autoplayValue, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      navigation: this.navigationValue
        ? { nextEl: this.element.querySelector(".swiper-button-next"), prevEl: this.element.querySelector(".swiper-button-prev") }
        : false,
      pagination: this.paginationValue
        ? { el: this.element.querySelector(".swiper-pagination"), clickable: true }
        : false
    })
  }

  disconnect() {
    // Évite les instances en double d'une visite Turbo à l'autre.
    this.swiper?.destroy(true, true)
  }
}
